export const iconFontAwesomePoliticalDumpsterFire = (
	<i className="fa-solid fa-dumpster-fire"></i>
);
